// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredients__BreadBottom__16czh","BreadTop":"BurgerIngredients__BreadTop__1F9cD","Seeds1":"BurgerIngredients__Seeds1__1KqDN","Seeds2":"BurgerIngredients__Seeds2__1j0Rg","Meat":"BurgerIngredients__Meat__1kFCF","Cheese":"BurgerIngredients__Cheese__3JVcn","Salad":"BurgerIngredients__Salad__142r8","Bacon":"BurgerIngredients__Bacon__3LSem"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredients/BurgerIngredients.css
// module id = 108
// module chunks = 0